import { render, staticRenderFns } from "./DocumentationInput.vue?vue&type=template&id=e288a2b2&"
import script from "./DocumentationInput.vue?vue&type=script&lang=js&"
export * from "./DocumentationInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports